import { Component, OnInit } from '@angular/core';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

@Component({
  selector: 'app-request-entity',
  templateUrl: './request-entity.component.html',
  styleUrls: ['./request-entity.component.scss'],
})
export class RequestEntityComponent implements OnInit {

  isBtnDisabled = true;
  listRequestLoan: any;
  option: number;
  requestEntitySelected: any;

  constructor(
    private headerService: HeaderService,
    public copyService: CopyService,
    private navigationService: NavigationService,
    private parameterService: ParametersService,
    public abreCuentasService: AbreCuentasService,
  ) {
    this.headerService.show(true, true, true);
  }

  ngOnInit() {
    this.listRequestLoan = this.parameterService.getSetting(OpEnum.REQUEST_ENTITY_SI);
    this.requestEntitySelected = this.abreCuentasService.getRequestEntity();
    if (this.requestEntitySelected) {
      this.isBtnDisabled = false;
      this.option = this.requestEntitySelected;
    }
  }

  selectRequestLoan(value: any) {
    this.isBtnDisabled = false;
    this.option = value;
  }

  fillDestinationType() {
    let destinationType: string;
    if (this.option === 1) {
      destinationType = '02';
    } else if (this.option === 2) {
      destinationType = '01';
    } else {
      destinationType = '03';
    }
    return destinationType;
  }

  next() {
    this.abreCuentasService.setProductDestinationType(this.fillDestinationType());
    this.abreCuentasService.setRequestEntity(this.option);
    this.abreCuentasService.getPostlogin() ? this.navigationService.nextStep('201') :
    this.navigationService.nextStep('200');
  }

}
